import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import parameters from '@atlassian/jira-relay/src/__generated__/JswExpandableProjectQuery.graphql';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';

/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */
import { getProjectKey } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';

const NO_OF_BOARDS_TO_FETCH = 25;

export const nav4JSWProjectEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "nav4-jsw-project-entry-point" */ './JswExpandableProjectQuery'
			).then(({ JswExpandableProjectQuery }) => JswExpandableProjectQuery),
		{ includeInShellOnlySsrBundle: true, entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: (params: EntryPointRouteParams) => {
		const cloudId = params.tenantContext?.cloudId ?? '';
		let projectKey = '';
		if (params.context?.match.params?.projectKey) {
			projectKey = params.context.match.params.projectKey;
		} else if (params.context?.match.params?.issueKey && fg('move-issue-view-to-entrypoint')) {
			projectKey = getProjectKey(params.context.match, params.context.query);
		}
		return {
			queries: {
				projects: {
					parameters,
					variables: {
						cloudId,
						projectKey,
						noOfBoardsToFetch: NO_OF_BOARDS_TO_FETCH,
					},
				},
			},
		};
	},
});
